module.exports = __webpack_public_path__ + "images/accents/accent-sound-wave@2x-157ea025049ba13a2c3d7c382fa0a3e0.webp";